export default __webpack_public_path__ + "static/media/i (22).3cb1a7b8.jpg";